import { render } from "./CrumbsProfile.vue?vue&type=template&id=4fb1836a"
import script from "./CrumbsProfile.vue?vue&type=script&lang=js"
export * from "./CrumbsProfile.vue?vue&type=script&lang=js"

import "./CrumbsProfile.vue?vue&type=style&index=0&id=4fb1836a&lang=scss"
script.render = render

export default script